export const environment = {
  production: false,
  name: 'dev',
  keycloak: {
    issuer: 'https://mylogin.ciam.preprod.aws.scania.com/auth',
    realm: 'fg-ext',
    clientId: 'cs_chs_mission_frontend',
    checkLoginIframe: false,
  },
  myScaniaUi: 'https://myscania.test.cs.scania.com/start',
  chargingServiceUi: 'https://ui.chargingservicestest.prod.gf.aws.scania.com/',
  missionApi: 'https://mission-api.chargingservices.devtest.gf.aws.scania.com',
  adminApi: 'https://admin.chargingservices.devtest.gf.aws.scania.com',
  charegePointApi: 'https://chargepoint.chargingservicestest.prod.gf.aws.scania.com/v2',
};
